import useToastContext from "hooks/useToastContext";
import { AiFillEdit, AiFillDelete } from "react-icons/ai"; // Added AiFillDelete
import { apiPut, apiDelete } from "../../../utils/apiFetch"; // Added apiDelete
import apiPath from "../../../utils/apiPath";
import dayjs from "dayjs";
import { useTranslation } from "react-i18next";
import AuthContext from "context/AuthContext";
import { useContext } from "react";
import { isEmpty } from "lodash";
import helper from "../../../utils/helpers";
import { BsArrowUpShort } from "react-icons/bs";
import TableHeaderCell from "components/reusable/TableHeaderCell";
import { sortingOptionsSubCategory } from "utils/constants";

const SubCategoryList = ({ subcategoryList, page, allSubCategory, handleEdit, sort, setSort, manager }) => {
  const notification = useToastContext();
  const { t } = useTranslation();
  const { user } = useContext(AuthContext);

  const handelStatusChange = async (item) => {
    try {
      const payload = {
        status: item?.status === "inactive" ? "active" : "inactive",
      };
      const path = `${apiPath.subCategoryStatus}/${item?._id}`;
      const result = await apiPut(path, payload);
      if (result?.status === 200) {
        notification.success(result.data.message);
        allSubCategory({ statusChange: 1 });
      }
    } catch (error) {
      console.log("error in get all subcategory list==>>>>", error.message);
    }
  };

  // Added Delete Function
  const handleDeleteItem = async (item) => {
    try {
      const path = `${apiPath.subcategory}/${item?._id}`; // Adjust path according to your apiPath constants
      const result = await apiDelete(path);
      if (result?.status === 200) {
        notification.success(result.data.message);
        allSubCategory({ deletePage: 1 });
      }
    } catch (error) {
      notification.error(error?.response?.data?.message || "Error deleting subcategory");
    }
  };

  const confirmDelete = (item) => {
    helper.alertFunction(
      `Are you sure you want to delete '${item.name}'?`,
      item,
      handleDeleteItem
    );
  };

  const handleSortTableItem = (sortByValue, sortTypeValue) => {
    const newSortType = sort.sortType === "asc" ? "desc" : "asc";
    setSort({
      sortBy: sortByValue,
      sortType: sortByValue === sort.sortBy ? newSortType : sortTypeValue,
    });
  };

  const handleStatusChangeItem = (item, e) => {
    helper.alertFunction(`Are you sure you want to ${e.target.checked ? "active" : "inactive"} '${item.name}'?`, item, handelStatusChange);
  };

  return (
    <div>
      <div className="p-3">
        <div className="overflow-x-auto relative rounded-lg border">
          <table className="w-full text-xs text-left text-[#6c6c6c] dark:text-gray-400 ">
            <thead className="text-xs text-gray-900 border border-[#E1E6EE] bg-[#E1E6EE] dark:bg-gray-700 dark:text-gray-400">
              <tr>
                <TableHeaderCell text={t("SR_NO")} />
                <TableHeaderCell text={t("CATEGORY_NAME")} />
                <TableHeaderCell text={t("SUB_CATEGORY_NAME")} />
                {sortingOptionsSubCategory?.map((option) => (
                  <th onClick={() => handleSortTableItem(option.sortBy, "asc")} key={option.sortBy} scope="col" className="cursor-pointer py-3 px-6 ">
                    <div className="flex justify-start">
                      <span>{option.displayText}</span>
                      <span>
                        {sort.sortType === "asc" && sort.sortBy === option.sortBy && <BsArrowUpShort className="w-4 h-4" />}
                        {sort.sortBy === option.sortBy && sort.sortType === "desc" && <BsArrowUpShort className="rotate-180 w-4 h-4 " />}
                      </span>
                    </div>
                  </th>
                ))}

                <th scope="col" className="py-3 px-6 text-center">
                  {t("O_STATUS")}
                </th>
                {(manager?.edit || user?.role === "admin") && (
                  <th scope="col" className="py-3 px-6 text-center">
                    {t("O_ACTION")}
                  </th>
                )}
              </tr>
            </thead>
            <tbody>
              {subcategoryList &&
                subcategoryList.map((item, i) => {
                  return (
                    <tr key={i} className="bg-white border-b dark:bg-gray-800 dark:border-gray-700">
                      <th scope="row" className="py-4 px-6 border-r font-medium text-gray-900  dark:text-white">
                        {i + 1 + 10 * (page - 1)}
                      </th>
                      <td className="py-4 px-6 border-r text-gray-900">{item?.Category?.name}</td>
                      <td className="py-4 px-6 border-r text-gray-900">{item?.name}</td>
                      <td className="py-4 px-6 border-r text-gray-900">{dayjs(item?.createdAt).format("MM-DD-YYYY h:mm A")} </td>
                      <td className="text-gray-900 py-4 px-6 border-r ">{dayjs(item?.updatedAt).format("MM-DD-YYYY h:mm A")} </td>

                      <td className="border-r text-center py-4 px-6 text-gray-900">
                        <label title={`${item?.status === "active" ? "Active" : "Inactive"}`} className="items-center cursor-pointer inline-flex relative ">
                          <input type="checkbox" onChange={(e) => handleStatusChangeItem(item, e)} className="sr-only peer" checked={item?.status === "active"} />
                          <div className="w-10 h-5 bg-gray-200 rounded-full peer peer-focus:ring-0 peer-focus:ring-blue-300 dark:peer-focus:ring-blue-800 dark:bg-gray-700 peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-4 after:w-4 after:transition-all dark:border-gray-600 peer-checked:bg-LightBlue" />
                        </label>
                      </td>
                      {(manager?.edit || user?.role === "admin") && (
                        <td className="py-4 px-6 border-l text-gray-900">
                          <div className="">
                            <ul className="flex justify-center gap-3">
                              <li onClick={() => handleEdit(item)} className="px-2 py-2 hover:bg-white hover:text-LightBlue">
                                <a title={t("EDIT_SUBCATEGORY")} className="hover:text-blue-700 transition duration-150 ease-in-out" data-bs-toggle="tooltip">
                                  {" "}
                                  <AiFillEdit className="cursor-pointer w-5 h-5 text-slate-600" />
                                </a>
                              </li>
                              {/* Added Delete Button */}
                              <li onClick={() => confirmDelete(item)} className="px-2 py-2 hover:bg-white hover:text-red-500">
                                <a title="Delete Subcategory" className="hover:text-red-700 transition duration-150 ease-in-out" data-bs-toggle="tooltip">
                                  <AiFillDelete className="cursor-pointer w-5 h-5 text-red-500" />
                                </a>
                              </li>
                            </ul>
                          </div>
                        </td>
                      )}
                    </tr>
                  );
                })}
              {isEmpty(subcategoryList) ? (
                <tr className="bg-white border-b text-center dark:bg-gray-800 dark:border-gray-700">
                  <td className="py-4 px-6 border-r" colSpan={7}>
                    {t("O_NO_RECORD_FOUND")}
                  </td>
                </tr>
              ) : null}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default SubCategoryList;





// import useToastContext from "hooks/useToastContext";
// import { AiFillEdit } from "react-icons/ai";
// import { apiPut } from "../../../utils/apiFetch";
// import apiPath from "../../../utils/apiPath";
// import dayjs from "dayjs";
// import { useTranslation } from "react-i18next";
// import AuthContext from "context/AuthContext";
// import { useContext } from "react";
// import { isEmpty } from "lodash";
// import helper from "../../../utils/helpers";
// import { BsArrowUpShort } from "react-icons/bs";
// import TableHeaderCell from "components/reusable/TableHeaderCell";
// import { sortingOptionsSubCategory } from "utils/constants";

// const SubCategoryList = ({ subcategoryList, page, allSubCategory, handleEdit, sort, setSort, manager }) => {
//   const notification = useToastContext();
//   const { t } = useTranslation();
//   const { user } = useContext(AuthContext);

//   const handelStatusChange = async (item) => {
//     try {
//       const payload = {
//         status: item?.status === "inactive" ? "active" : "inactive",
//       };
//       const path = `${apiPath.subCategoryStatus}/${item?._id}`;
//       const result = await apiPut(path, payload);
//       if (result?.status === 200) {
//         notification.success(result.data.message);
//         allSubCategory({ statusChange: 1 });
//       }
//     } catch (error) {
//       console.log("error in get all subcategory list==>>>>", error.message);
//     }
//   };

//   const handleSortTableItem = (sortByValue, sortTypeValue) => {
//     const newSortType = sort.sortType === "asc" ? "desc" : "asc";
//     setSort({
//       sortBy: sortByValue,
//       sortType: sortByValue === sort.sortBy ? newSortType : sortTypeValue,
//     });
//   };

//   const handleStatusChangeItem = (item, e) => {
//     helper.alertFunction(`Are you sure you want to ${e.target.checked ? "active" : "inactive"} '${item.name}'?`, item, handelStatusChange);
//   };

//   return (
//     <div>
//       <div className="p-3">
//         <div className="overflow-x-auto relative rounded-lg border">
//           <table className="w-full text-xs text-left text-[#6c6c6c] dark:text-gray-400 ">
//             <thead className="text-xs text-gray-900 border border-[#E1E6EE] bg-[#E1E6EE] dark:bg-gray-700 dark:text-gray-400">
//               <tr>
//                 <TableHeaderCell text={t("SR_NO")} />
//                 <TableHeaderCell text={t("CATEGORY_NAME")} />
//                 <TableHeaderCell text={t("SUB_CATEGORY_NAME")} />
//                 {sortingOptionsSubCategory?.map((option) => (
//                   <th onClick={() => handleSortTableItem(option.sortBy, "asc")} key={option.sortBy} scope="col" className="cursor-pointer py-3 px-6 ">
//                     <div className="flex justify-start">
//                       <span>{option.displayText}</span>
//                       <span>
//                         {sort.sortType === "asc" && sort.sortBy === option.sortBy && <BsArrowUpShort className="w-4 h-4" />}
//                         {sort.sortBy === option.sortBy && sort.sortType === "desc" && <BsArrowUpShort className="rotate-180 w-4 h-4 " />}
//                       </span>
//                     </div>
//                   </th>
//                 ))}

//                 <th scope="col" className="py-3 px-6 text-center">
//                   {t("O_STATUS")}
//                 </th>
//                 {(manager?.edit || user?.role === "admin") && (
//                   <th scope="col" className="py-3 px-6 text-center">
//                     {t("O_ACTION")}
//                   </th>
//                 )}
//               </tr>
//             </thead>
//             <tbody>
//               {subcategoryList &&
//                 subcategoryList.map((item, i) => {
//                   return (
//                     <tr key={i} className="bg-white border-b dark:bg-gray-800 dark:border-gray-700">
//                       <th scope="row" className="py-4 px-6 border-r font-medium text-gray-900  dark:text-white">
//                         {i + 1 + 10 * (page - 1)}
//                       </th>
//                       <td className="py-4 px-6 border-r text-gray-900">{item?.Category?.name}</td>
//                       <td className="py-4 px-6 border-r text-gray-900">{item?.name}</td>
//                       <td className="py-4 px-6 border-r text-gray-900">{dayjs(item?.createdAt).format("MM-DD-YYYY h:mm A")} </td>
//                       <td className="text-gray-900 py-4 px-6 border-r ">{dayjs(item?.updatedAt).format("MM-DD-YYYY h:mm A")} </td>

//                       <td className="border-r text-center py-4 px-6 text-gray-900">
//                         <label title={`${item?.status === "active" ? "Active" : "Inactive"}`} className="items-center cursor-pointer inline-flex relative ">
//                           <input type="checkbox" onChange={(e) => handleStatusChangeItem(item, e)} className="sr-only peer" checked={item?.status === "active"} />
//                           <div className="w-10 h-5 bg-gray-200 rounded-full peer peer-focus:ring-0 peer-focus:ring-blue-300 dark:peer-focus:ring-blue-800 dark:bg-gray-700 peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-4 after:w-4 after:transition-all dark:border-gray-600 peer-checked:bg-LightBlue" />
//                         </label>
//                       </td>
//                       {(manager?.edit || user?.role === "admin") && (
//                         <td className="py-4 px-6 border-l text-gray-900">
//                           <div className="">
//                             <ul className="flex justify-center">
//                               <li onClick={() => handleEdit(item)} className="px-2 py-2 hover:bg-white hover:text-LightBlue">
//                                 <a title={t("EDIT_SUBCATEGORY")} className="hover:text-blue-700 transition duration-150 ease-in-out" data-bs-toggle="tooltip">
//                                   {" "}
//                                   <AiFillEdit className="cursor-pointer w-5 h-5 text-slate-600" />
//                                 </a>
//                               </li>
//                             </ul>
//                           </div>
//                         </td>
//                       )}
//                     </tr>
//                   );
//                 })}
//               {isEmpty(subcategoryList) ? (
//                 <tr className="bg-white border-b text-center dark:bg-gray-800 dark:border-gray-700">
//                   <td className="py-4 px-6 border-r" colSpan={7}>
//                     {t("O_NO_RECORD_FOUND")}
//                   </td>
//                 </tr>
//               ) : null}
//             </tbody>
//           </table>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default SubCategoryList;
